export default __webpack_public_path__ + "static/media/position-status-5.66046129.svg";